import { useNavigate } from 'react-router-dom';
// Using the specific asset path you requested
import NotFoundImg from '@/res/imgs/404guy.webp';
import Page from '../container/Page';

const Error404 = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full w-full grid grid-rows-12 items-center justify-center p-6 text-center relative min-h-0 gap-y-2">
      {/* Playful Background Elements (Optional, adds depth) */}
      <div className="absolute top-1/4 left-10 w-24 h-24 bg-brand-truffle/30 rounded-full blur-2xl pointer-events-none" />
      <div className="absolute bottom-1/4 right-10 w-32 h-32 bg-brand-burgundy/20 rounded-full blur-2xl pointer-events-none" />

      {/* 1. Large Friendly Heading */}
      <h1 className="font-display text-7xl md:text-[8rem] text-brand-sage tracking-tight mb-2 select-none row-span-2">
        Oops!
      </h1>

      {/* 2. Central Graphic with subtle float animation */}
      <div className="flex w-full items-center justify-center relative h-full min-w-0 aspect-square mt-6 md:mt-10 animate-in fade-in zoom-in duration-700 row-span-4">
        <img
          src={NotFoundImg}
          alt="Lost baker looking sad with a giant whisk"
          className="w-full h-full object-contain drop-shadow-xl hover:-translate-y-2 transition-transform duration-500 ease-out"
        />
        {/* Subtle shadow anchor under the character */}
        <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-32 h-3 bg-black/5 rounded-[100%] blur-[2px]" />
      </div>

      {/* 3. The Broken Connection / Playful Pun Divider */}
      <div className="flex items-center gap-4 w-full max-w-xs mx-auto opacity-60 row-span-2">
        <div className="h-0.5 flex-1 bg-brand-truffle/60 rounded-full" />
        <span className="text-2xl font-shadow">🥚</span>
        <span className="text-2xl font-shadow">💨</span>
        <div className="h-0.5 flex-1 bg-brand-truffle/60 rounded-full" />
      </div>

      {/* 4. Error Messaging */}
      <h2 className="font-display !font-[700] text-2xl md:text-3xl text-text-heading leading-tight text-center row-span-1 w-full">
        Looks like things got a little mixed up.
      </h2>
      <p className="text-text-muted max-w-md text-sm md:text-base leading-relaxed font-[500] row-span-2 text-center w-full self-center justify-self-center">
        We can't seem to find the page you're looking for. It might have been
        whisked away, had its name changed, or is temporarily unavailable.
      </p>

      {/* 5. Primary CTA */}
      <button
        onClick={() => navigate('/')}
        className="px-10 py-4 bg-brand-burgundy text-white rounded-md font-display font-[500] text-sm tracking-widest uppercase lift transition-all duration-300 hover:bg-brand-burgundy/90 hover:-translate-y-1 w-fit justify-self-center"
      >
        Back to the Bakery
      </button>
    </div>
  );
};

export const ErrorPage = () => (
  <Page>
    <Error404 />
  </Page>
);

export default Error404;
